<template>
  <div class="wrap" v-loading="allLoading">
    <div class="main-wrap my-orders">
      <!-- 导航 -->
      <div class="order-navigation">
        <a
          class="text1"
          href="/#/catalogue"
        >{{L.home}}</a>
        <span class="line">/</span>
        <a
          class="text1"
          href="/#/shipment" 
        >{{L.myShipment}}</a>
        <span class="line">/</span>
        <a
          class="text2"
          :href="shipDetailUrl($route.query.shipId)"
        >{{headInfo.contractCode}}</a>
      </div>
      <!-- 单头 -->
      <div class="search-wrap">
        <div class="line">
          <div class="square">
            <div class="text-title">{{L.orderID}}:</div>
            <div class="text-value">{{headInfo.contractCode}}</div>
          </div>
          <div class="square">
            <div class="text-title">{{L.portName}}:</div>
            <div class="text-value">{{headInfo.portName}}</div>
          </div>
          <div class="square">
            <div class="text-title">{{L.productNo}}:</div>
            <div class="text-value">{{headInfo.module}}</div>
          </div>
          <div class="square">
            <div class="text-title">{{L.quantity}}:</div>
            <div class="text-value">{{headInfo.qty}}</div>
          </div>
        </div>
        <div class="line">
          <div class="square">
            <div class="text-title">{{L.unitPrice}}:</div>
            <div class="text-value">{{formatMoney(headInfo.price)}}</div>
          </div>
          <div class="square">
            <div class="text-title">{{L.totalAmount}}:</div>
            <div class="text-value">{{formatMoney(headInfo.amount)}}</div>
          </div>
          <div class="square">
            <div class="text-title">{{L.soldQuantity}}:</div>
            <div class="text-value">{{headInfo.outQty}}</div>
          </div>
          <div class="square">
            <div class="text-title">{{L.soldAmount}}:</div>
            <div class="text-value">{{formatMoney(headInfo.outAmount)}}</div>
          </div>
        </div>
      </div>
      <!-- 按钮 -->
      <div class="btn-wrap" v-if="headInfo.ifFinish=='N'">
        <div class="left">
          <div class="fill" @click="handleAdd">{{L.add}}</div>
        </div>
      </div>
      <!-- 表格 -->
      <div class="table-wrap">
        <el-table
          v-loading="tableLoading"
          :header-cell-style="getHeaderCellStyle"
          highlight-current-row
          size="small"
          :data="list"
          border
          style="width: 100%"
        >
          <el-table-column
            fixed="left"
            width="180"
            prop="dealerName"
            :label="tableLable.dealerName">
          </el-table-column>
          <el-table-column
            width="100"
            prop="salesDate"
            :label="tableLable.saleDate">
          </el-table-column>
          <el-table-column
            prop="module"
            width="150"
            :label="tableLable.productNo">
          </el-table-column>
          <el-table-column
            prop="qty"
            width="80"
            :label="tableLable.quantity">
          </el-table-column>
          <el-table-column
            prop="price"
            width="80"
            :label="tableLable.unitPrice">
            <template slot-scope="scope">
              <span>{{formatMoney(scope.row.price)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            width="120"
            prop="amount"
            :label="tableLable.totalAmount">
            <template slot-scope="scope">
              <span>{{formatMoney(scope.row.amount)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="amountNottxt"
            :label="tableLable.amountNotTaxed">
            <template slot-scope="scope">
              <span>{{formatMoney(scope.row.amountNottxt)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="customerName"
            width="220"
            :label="tableLable.customerName">
          </el-table-column>
          <el-table-column
            prop="platform"
            width="110"
            :label="tableLable.platform">
          </el-table-column>
          <!-- 表格没数据的时候展示空组件，要注意这里的slot=empty不能随意更改 -->
          <div slot="empty">
            <NoContent/>
          </div>
        </el-table>
        <Pagination :pageObj="paginationObj" @sizeChange="sizeChange" @currentChange="currentChange"/>
      </div>
    </div>
    <!-- 弹窗-新增 -->
    <Add ref="Add" @afterAdd="afterAdd"/>
  </div>
</template>

<script>
import {postAction} from '@/api/tool'
import {api_led_ship_detail_head,api_led_ship_detail_body} from '@/api/api'
import NoContent from '@/components/NoContent'
import Pagination from '@/components/Pagination'
import Add from './Add'

export default {
  name:'CreditNotesList',
  components:{
    NoContent,
    Pagination,
    Add
  },
  data(){
    return {
      headInfo:{},
      list:[], //列表数据
      tableLoading:false,
      tableLable:{
        dealerName:'',
        saleDate:'',
        productNo:'',
        quantity:'',
        unitPrice:'',
        totalAmount:'',
        amountNotTaxed:'',
        customerName:'',
        platform:''
      } //表格的表头，因为这个地方切换语言的时候没办法正常渲染，所以需要监听语言包的变化，进行重新渲染
    }
  },
  watch:{
    L(newVal){
      this.tableLable=newVal
    }
  },
  methods:{
    /* 弹窗添加完之后的回调 */
    afterAdd(){
      this.getHead()
      this.getList()
    },
    /* 获取列表,如果是2的话，从第一页开始 */
    getHead(){
      let url = api_led_ship_detail_head + '/' + this.$route.query.shipId
      this.allLoading=true
      postAction(url).then(res=>{
        this.allLoading=false
        this.headInfo=res
      }).catch(()=>{
        this.allLoading=false
      })
    },
    /* 获取列表,如果是2的话，从第一页开始 */
    getList(flag=1){
      let obj = {}
      if(flag==2){
        this.paginationObj.currentPage=1
      }
      obj.pageNo=this.paginationObj.currentPage
      obj.pageSize=this.paginationObj.pageSize
      obj.params={
        bodyId:this.$route.query.shipId
      }
      this.tableLoading=true
      postAction(api_led_ship_detail_body,obj).then(res=>{
        this.tableLoading=false
        this.paginationObj.total=Number(res.total)
        this.list=res.records
      }).catch(()=>{
        this.tableLoading=false
      })
    },
    /* 展示新增弹窗 */
    handleAdd(){
      let obj = {
        contractCode:this.headInfo.contractCode,
        module:this.headInfo.module,
        platform:this.headInfo.platform,
        price:this.headInfo.price,
        bodyId:this.headInfo.bodyId
      }
      this.$refs.Add.open(obj)
    }
  },
  mounted(){
    this.tableLable=this.L
    this.getHead()
    this.getList(2)
  }
}
</script>

<style lang="less" scoped>
@import url('/public/css/public.less');
@import url('./index.less');
</style>

